import React from 'react';
import { WidgetStrategyWithRestApiByRequestUid } from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { CorporateActionsCapsule } from 'widgets/corpActions/capsule/components/CorporateActionsCapsule';
import { corporateActionsStreamConfig } from 'widgets/corpActions/store/data/stream-config';
import {
    CorporateActionsCapsuleConfigState,
    initialCorporateActionsCapsuleConfigState,
} from 'widgets/corpActions/capsule/store/CorporateActionsCapsuleConfigState';
import { corporateActionsCapsuleDescription } from 'widgets/corpActions/capsule/components/description/corporateActionsCapsuleDescription';
import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import CorporateActionsCapsuleSettings from 'widgets/corpActions/capsule/components/CorporateActionsCapsuleSettings';
import { CorporateActionsCapsuleMyPortfolioCapsuleContent } from 'widgets/corpActions/capsule/components/CorporateActionsCapsuleMyPortfolioCapsuleContent';
import { SymbolEventsRequest } from 'widgets/corpActions/api/SymbolEventsRequest';
import { SymbolEventsResponse } from 'widgets/corpActions/api/SymbolEventsResponse';

export const corporateActionsCapsuleWidgetStrategy: MyPortfolioCapsuleWidgetStrategyWithConfig<CorporateActionsCapsuleConfigState> &
    WidgetStrategyWithRestApiByRequestUid<
        SymbolEventsRequest,
        SymbolEventsResponse
    > = {
    title: 'Events',
    supportedHosts: ['tile'],
    reactComponentType: CorporateActionsCapsule,
    categories: [WidgetCategory.TOP],
    description: corporateActionsCapsuleDescription,
    portfolioSelectionRequirements: PortfolioSelectionRequirements.SingleSymbol,
    managedStreamConfig: corporateActionsStreamConfig,
    initialConfigState: initialCorporateActionsCapsuleConfigState,
    supportsMyPortfolioCapsule: true,
    supportsMyPortfolioCapsuleConfig: true,
    renderSettingsBody,
    myPortfolioCapsuleContentReactComponentType:
        CorporateActionsCapsuleMyPortfolioCapsuleContent,
    useMessagesInMyPortfolioCapsules: () => [],
};

function renderSettingsBody(
    config: CorporateActionsCapsuleConfigState,
    onChange: (configDelta: Partial<CorporateActionsCapsuleConfigState>) => void
) {
    return (
        <CorporateActionsCapsuleSettings config={config} onChange={onChange} />
    );
}
